/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Position_X_Offset_TooltipInputs */



/**
* | output |
* | --- |
* | "Check for Events where the horizontal offset is set." |
*
* @param {Style_Guide_Manager_Position_X_Offset_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_position_x_offset_tooltip = /** @type {((inputs?: Style_Guide_Manager_Position_X_Offset_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Position_X_Offset_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verifier les evenements ou le decalage horizontal est defini.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfen Sie, ob Ereignisse mit einem festgelegten horizontalen Versatz vorliegen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controllare gli eventi in cui è impostato lo spostamento orizzontale.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверьте события, в которых задано горизонтальное смещение.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comprueba si hay eventos en los que esté establecido el desplazamiento horizontal.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("检查是否存在设置了水平偏移量的事件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("水平オフセットが設定されているイベントを確認します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उन इवेंट्स की जांच करें जहां हॉरिजॉन्टल ऑफसेट सेट किया गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Verifique os eventos em que o deslocamento horizontal está definido.")
	return /** @type {LocalizedString} */ ("Check for Events where the horizontal offset is set.")
});